import React from 'react'
import cn from 'classnames'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

const ChevronIcon = (props) => {
  return (
    <svg
      width={7}
      height={13}
      viewBox="0 0 7 13"
      fill="none"
      {...props}
    >
      <path
        stroke="#8A949F"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.332 12.167.499 6.334 6.332.5"
      />
    </svg>
  )
}

const DateSelector = ({date, onChange}) => {
  const { t } = useTranslation()

  const handleChange = (date) => {
    onChange(date)
  }

  return (
    <div className={styles.container}>
      {
        !moment(date).isSame(moment(), 'day')
          ? <div className={styles.today} onClick={() => handleChange(moment())}>{t('Today')}</div>
          : null
      }
      <div className={cn(styles.button, styles.prev)} onClick={() => handleChange(date.clone().subtract(1, 'day'))}>
        <ChevronIcon />
      </div>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          disableToolbar
          variant='inline'
          value={date}
          onChange={handleChange}
          className={styles.datePicker}
          format="dddd, MMMM D, YYYY"
        />
      </MuiPickersUtilsProvider>
      <div className={cn(styles.button, styles.prev)} onClick={() => handleChange(date.clone().add(1, 'day'))}>
        <ChevronIcon style={{transform: 'rotate(180deg)'}} />
      </div>
    </div>
  )
}

export default DateSelector
